import React from 'react'
import './detection.css'

class Detection extends React.Component {
  constructor (props) {
    super (props)
    this.state = {
    }
  }
  render () {
    return(
      <div className='detection_result'>
        <div className='detection_result_div'>
          <h4>检测结果</h4>
          <ul>

          </ul>
        </div>
      </div>
    )
  }

  /*
  <li>
    <span><i class="yellow-point"></i></span>
    <span class="list-content">每句话开头前两个词中，必须是动词</span>
  </li>
  */
}
export default Detection
